import React, { ReactNode, useMemo } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import * as S from '@r1-frontend/ui-react/organisms/Card/CardImage/styled';
import { customDotsStyles, CustomNukaCarousel } from '@r1-frontend/ui-react/organisms/Card/CustomNuka';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

type TProps = {
    images: string[],
    labels?: ReactNode[],
}

const CardImageWithCarousel = (props: TProps): JSX.Element => {
    const isMobile = useMatchMediaByWidth(wideBreakpoints.mobile);

    const {
        images,
        labels,
    } = useMemo(() => {
        return {
            images: isMobile ? props.images.slice(0, 1) : props.images,
            labels: props.labels && isMobile ? props.labels.slice(0, 1) : props.labels,
        };
    }, [props.images, props.labels, isMobile]);

    return (
        <CustomNukaCarousel
            data-test={'Equipment_CustomNukaCarousel'}
            withoutArrows={true}
            customDotsStyles={customDotsStyles}
            height={isMobile ? '80px' : '112px'}
        >
            {images.map((currentImage, index) => {
                return !!labels && index === 0
                    ? <div key={`Carousel_item_${currentImage}`}>
                        <S.LabelWrapper>{labels}</S.LabelWrapper>
                        <LazyLoadImage src={currentImage} alt={'equipment'} visibleByDefault={true}/>
                    </div>
                    : <LazyLoadImage src={currentImage} key={`Carousel_item_${currentImage}`} alt={'equipment'}/>;
            })}
        </CustomNukaCarousel>
    );
};

export default CardImageWithCarousel;
